import React from 'react';

import E_SDG from '../../images/E_SDG_Icons-18.jpg';

class SDGSALWImage extends React.PureComponent {
  render() {
    return (
      <div className={ this.props.className }>
        <img
          style={{
            width: '150px',
            height: 'auto',
            margin: '0 auto 10px',
            display: 'block'
          }}
          src={ E_SDG }
          alt={'SDG'}
        />
      </div>
    );
  }
}

export default SDGSALWImage;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGSALWImage.js